export default __webpack_public_path__ + "static/project-slide-4-992-765-6079a775ba414445b54b581b9590fc33.jpg";